<script context="module">
  const getWidth = / width="([0-9]+)" /;
  const getHeight = / height="([0-9]+)" /;
</script>

<script>
  import {conf} from '@convincely/utils/lib/services/conf.js';
  import {cacheService} from '@convincely/utils/lib/services/cache.js';
  import {svgProcess} from '@convincely/utils/lib/svg.js';
  import {createEventDispatcher, tick} from '../../library.js';
  import {animate} from '../../actions/animations.js';

  let ref;
  let originalWidth = 0;
  let originalHeight = 0;

  let className = undefined;
  export {className as class};
  export let cache = conf.cacheService || cacheService;
  export let focusable = false;
  export let src;
  export let width = 0;
  export let height = 0;
  export let style = undefined;
  export let animation = undefined;
  export let tabIndex = undefined;

  let content;
  const dispatch = createEventDispatcher();

  $: getSvg(src);

  if (import.meta.env.SSR) {
    serverSvg();
  }

  async function getSvg(resource) {
    content = svgProcess(await cache.preloadIcon(resource));
    await tick();
    process();
  }

  function process() {
    if (!ref) {
      return;
    }

    const element = ref.firstElementChild;

    if (!element) {
      return;
    }

    dispatch('load', element);
    const getWidth = element.getAttribute('width');

    if (getWidth) {
      originalWidth = getWidth;
    }

    const getHeight = element.getAttribute('height');

    if (getHeight) {
      originalHeight = getHeight;
    }

    element.setAttribute('focusable', focusable);

    if (!width && !height) {
      element.setAttribute('width', originalWidth);
      element.setAttribute('height', originalHeight);

      return;
    }

    if (width) {
      element.setAttribute('width', width);

      if (!height) {
        element.removeAttribute('height');
      }
    }

    if (height) {
      element.setAttribute('height', height);

      if (!width) {
        element.removeAttribute('width');
      }
    }
  }

  async function serverSvg() {
    if (!window?.node) {
      return;
    }

    const {fs, path} = window.node;

    try {
      const content = fs.readFileSync(path.resolve('public', src), 'utf8');
      const [, serverWidth] = content.match(getWidth) || [];
      const [, serverHeight] = content.match(getHeight) || [];

      if (serverWidth) {
        originalWidth = serverWidth;
      }

      if (serverHeight) {
        originalHeight = serverHeight;
      }
    } catch (e) {
    //
    }
  }
</script>

<span bind:this={ref} class:conv-icon={true} class:conv-icon-custom-animate={animation} class={className} on:click {tabIndex} {style}>
  {#if content}
    {#if animation}
      <span use:animate={animation}>{@html content}</span>
    {:else}
      {@html content}
    {/if}
  {:else}
    <svg xmlns="http://www.w3.org/2000/svg" width={originalWidth} height={originalHeight} viewBox="0 0 {originalWidth} {originalHeight}" focusable="false"></svg>
  {/if}
</span>
